import { OptionType } from "@/services/customer-management/customer-list";
import dayjs from "dayjs";
// 秒格式化成时分秒
export function timeFormat(second: number) {
  const dur = dayjs.duration(second, "seconds");
  return dur.format("HH:mm:ss");
}

export const sleep = (timeout: number) => {
  return new Promise((resolve) => {
    const timer = setTimeout(() => {
      resolve(null);
      clearTimeout(timer);
    }, timeout);
  });
};
export function getSecondLevelDomain() {
  // 将URL转换为小写字母
  const urls = window.location.hostname.split(".");
  if (urls?.length === 1) {
    return urls[0];
  }
  urls.shift();
  return urls.join(".");
}

export const debounceFn = <T>(
  cb: (params: T) => void | (() => void),
  timeout: number,
  // 当太长时间无法执行callback而又需要强制执行callback，可以设置这个参数
  forceUpdateTime?: number
) => {
  let timer: NodeJS.Timeout;
  let forceUpdateTimer: NodeJS.Timeout;
  return function (params?: T) {
    if (!forceUpdateTimer && forceUpdateTime) {
      forceUpdateTimer = setTimeout(() => {
        cb(params!);
        clearTimeout(forceUpdateTimer);
        forceUpdateTimer = null!;
      }, forceUpdateTime);
    }
    if (timer) {
      clearTimeout(timer);
      timer = null!;
      return;
    }
    timer = setTimeout(() => {
      cb(params!);
      clearTimeout(timer);
      timer = null!;
      if (forceUpdateTimer) {
        clearTimeout(forceUpdateTimer);
        forceUpdateTimer = null!;
      }
    }, timeout);
  };
};

export function pick<T, K extends keyof T>(obj: T, keys: K[]): Pick<T, K> {
  const result = {} as Pick<T, K>;
  for (const key of keys) {
    result[key] = obj[key];
  }
  return result;
}

export function dealAreaText(
  areaOptions: OptionType[],
  area: {
    country: string;
    province: string;
    city: string;
  }
) {
  const country = areaOptions?.find((item) => item?.value === area?.country);
  const province = country?.children?.find(
    (item) => item?.value === area?.province
  );
  const city = province?.children?.find((item) => item?.value === area?.city);
  let text = "";
  if (country) {
    text += country?.label;
  }
  if (province) {
    text += `-${province?.label}`;
  }
  if (city) {
    text += `-${city?.label}`;
  }
  if (!text) {
    text = "--";
  }
  return text;
}
